import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import RateInput from '../common/RateInput';
import { putRequest } from '../../requestUtils';
import SelectInputWithSymbol from '../common/SelectInputWithSymbol/SelectInputWithSymbol';
import dollarImage from '../../../assets/images/icons/dollar.svg';
import './ExecuteAgreementForProject.scss';

const requiredFields = ['netRate', 'travelRate', 'grossRate', 'grossTravelRate'];

class ExecuteAgreementForProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      netRate: null,
      travelRate: null,
      grossRate: null,
      grossTravelRate: null,
      hourLimit: null,
      projectTakeRate: props.projectTakeRate,
      quickbooksPaymentTerm: props.quickbooksPaymentTerm,
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleUpdateProposal = this.handleUpdateProposal.bind(this);
    this.updateTakeRate = this.updateTakeRate.bind(this);
  }

  ableToSubmit() {
    return requiredFields.reduce((soFar, field) => soFar && this.state[field], true);
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  handleUpdateProposal() {
    const { csrfToken, executeAgreementUrl } = this.props;
    const {
      netRate,
      travelRate,
      grossRate,
      grossTravelRate,
      hourLimit,
      projectTakeRate,
      quickbooksPaymentTerm,
    } = this.state;

    const rates = {
      net_rate: netRate * 100,
      travel_rate: travelRate * 100,
      gross_rate: grossRate * 100,
      gross_travel_rate: grossTravelRate * 100,
    };

    putRequest(
      executeAgreementUrl,
      {
        rates,
        hour_limit: hourLimit,
        clora_take_rate: projectTakeRate,
        quickbooks_payment_term: quickbooksPaymentTerm,
      },
      csrfToken,
    ).then(() => {
      window.location.reload();
    });
  }

  calculatedTakeRate() {
    const { netRate, grossRate } = this.state;

    const rawRate = 1.0 - (netRate / grossRate);
    return Math.round(rawRate * 10000) / 100;
  }

  updateTakeRate() {
    if (isNaN(this.calculatedTakeRate()) || this.calculatedTakeRate() < 0) return;

    this.setState({ projectTakeRate: this.calculatedTakeRate() });
  }

  handleChange(val, name) {
    this.setState({ [name]: val }, this.updateTakeRate);
  }

  render() {
    const {
      style, triggerText, triggerStyle, quickbooksPaymentTermOptions,
    } = this.props;
    const {
      netRate,
      travelRate,
      grossRate,
      grossTravelRate,
      hourLimit,
      projectTakeRate,
      quickbooksPaymentTerm,
    } = this.state;
    return (
      <ModalTrigger
        triggerText={triggerText}
        buttonStyles={`btn btn-sm ${style} ${triggerStyle}`}
        submitButtonText="Execute Agreement"
        submitDisabled={!this.ableToSubmit()}
        cancelButtonText="Cancel"
        handleSubmit={this.handleUpdateProposal}
        triggerType="link"
        idKey="execute-agreement-for-project-modal"
        modalSize="md"
      >
        <div className="style-guide">

          <div className=" mb-3 ">
            <h2 className="mb-1 required">Employer Hourly Rate (Gross)</h2>
            <RateInput
              id="proposal-gross-rate"
              value={grossRate}
              onAnswerChange={(val) => this.handleChange(val, 'grossRate')}
              placeholder="Gross Hourly Rate"
            >
              <img className="pe-2" src={dollarImage} alt="dollar sign" />
            </RateInput>
          </div>

          <div className=" mb-3 ">
            <h2 className="mb-1 required">Consultant Hourly Rate (Net)</h2>
            <RateInput
              id="proposal-net-rate"
              value={netRate}
              onAnswerChange={(val) => this.handleChange(val, 'netRate')}
              placeholder="Net Hourly Rate"
            >
              <img className="pe-2" src={dollarImage} alt="dollar sign" />
            </RateInput>
          </div>

          <div className=" mb-3 ">
            <h2 className="mb-1 required">Employer Travel Rate (Gross)</h2>
            <RateInput
              id="proposal-gross-travel-rate"
              value={grossTravelRate}
              onAnswerChange={(val) => this.handleChange(val, 'grossTravelRate')}
              placeholder="Gross Travel Rate"
            >
              <img className="pe-2" src={dollarImage} alt="dollar sign" />
            </RateInput>
          </div>

          <div className=" mb-3 ">
            <h2 className="mb-1 required">Consultant Travel Rate (Net)</h2>
            <RateInput
              id="proposal-travel-rate"
              value={travelRate}
              onAnswerChange={(val) => this.handleChange(val, 'travelRate')}
              placeholder="Net Travel Rate"
            >
              <img className="pe-2" src={dollarImage} alt="dollar sign" />
            </RateInput>
          </div>

          <div className=" mb-3 ">
            <h2 className="mb-1">Monthly Hourly Limit (optional)</h2>
            <div className="input- w-50">
              <input
                id="proposal-hour-limit"
                type="number"
                className="form-control rate-input"
                value={hourLimit}
                onChange={(e) => this.handleChange(e.target.value, 'hourLimit')}
                placeholder="Max Hours"
              />
            </div>
          </div>
          <div className=" mb-3 ">
            <h2 className="mb-1 required">Project Take Rate</h2>
            <div className="input-group w-50">
              <input
                id="project-take-rate"
                type="number"
                className="form-control rate-input"
                value={projectTakeRate}
                placeholder="Project Take Rate"
                readOnly
              />
            </div>
          </div>
          <SelectInputWithSymbol
            label={<h2 className="input-label" style={{ color: '#007766' }} required>Quickbooks Payment Term</h2>}
            placeholder="Quickbooks Payment Term"
            inputName="quickbooksPaymentTerm"
            onChange={(e) => this.handleChange(e.value, 'quickbooksPaymentTerm')}
            errors=""
            containerWidth="80%"
            value={{ value: quickbooksPaymentTerm, label: quickbooksPaymentTerm }}
            options={quickbooksPaymentTermOptions}
          />
        </div>
      </ModalTrigger>
    );
  }
}

ExecuteAgreementForProject.propTypes = {
  style: PropTypes.string,
  triggerStyle: PropTypes.string,
  triggerText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  csrfToken: PropTypes.string.isRequired,
  executeAgreementUrl: PropTypes.string.isRequired,
  projectTakeRate: PropTypes.number.isRequired,
  quickbooksPaymentTerm: PropTypes.string.isRequired,
  quickbooksPaymentTermOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

ExecuteAgreementForProject.defaultProps = {
  triggerStyle: '',
  triggerText: 'Executed Agreement',
  style: '',
  quickbooksPaymentTermOptions: [],
};

export default ExecuteAgreementForProject;
